import { render, staticRenderFns } from "./promotionModal.vue?vue&type=template&id=773e8933&scoped=true"
import script from "./promotionModal.vue?vue&type=script&lang=js"
export * from "./promotionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773e8933",
  null
  
)

export default component.exports